import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=f86f07d4&scoped=true"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=f86f07d4&prod&lang=css"
import style1 from "./ProfileForm.vue?vue&type=style&index=1&id=f86f07d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86f07d4",
  null
  
)

export default component.exports